import { render, staticRenderFns } from "./statement-import-details.vue?vue&type=template&id=bbb166c6&scoped=true"
import script from "./statement-import-details.vue?vue&type=script&lang=ts"
export * from "./statement-import-details.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbb166c6",
  null
  
)

export default component.exports